export default "__VITE_ASSET__n5HvbqoP__"